import React from 'react';
import { SubmitHandler } from 'react-hook-form';

import { useMessage } from '@ott/message';

import { FormValues, ToastData } from '../../../types';
import FormRequest from '../formRequest';
import ContactForm from './ContactForm';

const ContactFormFeature = () => {
  const messageApi = useMessage();

  const onSubmitHandler: SubmitHandler<FormValues> = async (data) => {
    const toast: ToastData = await FormRequest({ values: data });
    messageApi.open(toast.message, {
      style: {
        backgroundColor: toast.backgroundColor,
        color: 'white',
      },
    });
  };

  return <ContactForm onSubmit={onSubmitHandler} />;
};

export default ContactFormFeature;
